var render = function render(){var _vm=this,_c=_vm._self._c;return _c('limited-feature-tooltip',{directives:[{name:"show",rawName:"v-show",value:(_vm.planName),expression:"planName"}],attrs:{"permission":_vm.permission,"addon":_vm.addon,"hide":_vm.hide}},[_c('p-badge',{staticClass:"ml-2",attrs:{"tone":_vm.color},nativeOn:{"click":function($event){_vm.$store.commit('app/addManualHistory', _vm.$route);
      _vm.$router.push({
        name: 'PlanPick',
        query: { selectedPlan: _vm.planName.toString().toLowerCase() },
      });}}},[_vm._v(" "+_vm._s(_vm.planName)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }